/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getNboRecBacktestResult = /* GraphQL */ `
  query GetNboRecBacktestResult($id: ID!) {
    getNboRecBacktestResult(id: $id) {
      id
      purchase_train
      bp_id
      recommendations
      purchase_test
      createdAt
      updatedAt
    }
  }
`;
export const listNboRecBacktestResults = /* GraphQL */ `
  query ListNboRecBacktestResults(
    $filter: ModelNboRecBacktestResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNboRecBacktestResults(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        purchase_train
        bp_id
        recommendations
        purchase_test
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNboSurveyAnswers = /* GraphQL */ `
  query GetNboSurveyAnswers($id: ID!) {
    getNboSurveyAnswers(id: $id) {
      id
      result
      nboRecBacktestResultID
      createdBy
      nboRecBacktestResult {
        id
        purchase_train
        bp_id
        recommendations
        purchase_test
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      nboSurveyAnswersNboRecBacktestResultId
    }
  }
`;
export const listNboSurveyAnswers = /* GraphQL */ `
  query ListNboSurveyAnswers(
    $filter: ModelNboSurveyAnswersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNboSurveyAnswers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        result
        nboRecBacktestResultID
        createdBy
        nboRecBacktestResult {
          id
          purchase_train
          bp_id
          recommendations
          purchase_test
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        nboSurveyAnswersNboRecBacktestResultId
      }
      nextToken
    }
  }
`;
export const getMarketingTypeGroup = /* GraphQL */ `
  query GetMarketingTypeGroup($id: ID!) {
    getMarketingTypeGroup(id: $id) {
      id
      code
      name
      description
      marketingTypes {
        id
        code
        description
        marketingTypeGroup {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        marketingTypeGroupID
        isOrderConsumption
        isNGW
        isPsb
        createdBy
        createdAt
        updatedAt
      }
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listMarketingTypeGroups = /* GraphQL */ `
  query ListMarketingTypeGroups(
    $filter: ModelMarketingTypeGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMarketingTypeGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        name
        description
        marketingTypes {
          id
          code
          description
          marketingTypeGroupID
          isOrderConsumption
          isNGW
          isPsb
          createdBy
          createdAt
          updatedAt
        }
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getArticleType = /* GraphQL */ `
  query GetArticleType($id: ID!) {
    getArticleType(id: $id) {
      id
      code
      name
      description
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listArticleTypes = /* GraphQL */ `
  query ListArticleTypes(
    $filter: ModelArticleTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticleTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        name
        description
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOverwriteContractPayedRatio = /* GraphQL */ `
  query GetOverwriteContractPayedRatio($id: ID!) {
    getOverwriteContractPayedRatio(id: $id) {
      id
      contractPayedRatioTheshold
      minMax
      articleID
      article {
        id
        code
        title
        articleType {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        articleTypeID
        number
        isActive
        mandatorCode
        createdBy
        createdAt
        updatedAt
      }
      marketingTypeID
      marketingType {
        id
        code
        description
        marketingTypeGroup {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        marketingTypeGroupID
        isOrderConsumption
        isNGW
        isPsb
        createdBy
        createdAt
        updatedAt
      }
      conditionID
      condition {
        id
        code
        name
        description
        createdBy
        createdAt
        updatedAt
      }
      createdBy
      reason
      approvedControllingBy
      validFrom
      validTill
      approvedPublisherBy
      createdAt
      updatedAt
    }
  }
`;
export const listOverwriteContractPayedRatios = /* GraphQL */ `
  query ListOverwriteContractPayedRatios(
    $filter: ModelOverwriteContractPayedRatioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOverwriteContractPayedRatios(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contractPayedRatioTheshold
        minMax
        articleID
        article {
          id
          code
          title
          articleTypeID
          number
          isActive
          mandatorCode
          createdBy
          createdAt
          updatedAt
        }
        marketingTypeID
        marketingType {
          id
          code
          description
          marketingTypeGroupID
          isOrderConsumption
          isNGW
          isPsb
          createdBy
          createdAt
          updatedAt
        }
        conditionID
        condition {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        createdBy
        reason
        approvedControllingBy
        validFrom
        validTill
        approvedPublisherBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCondition = /* GraphQL */ `
  query GetCondition($id: ID!) {
    getCondition(id: $id) {
      id
      code
      name
      description
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listConditions = /* GraphQL */ `
  query ListConditions(
    $filter: ModelConditionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConditions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        name
        description
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOverwriteMonthInAboNull = /* GraphQL */ `
  query GetOverwriteMonthInAboNull($id: ID!) {
    getOverwriteMonthInAboNull(id: $id) {
      id
      minMax
      monthThreshold
      conditionID
      condition {
        id
        code
        name
        description
        createdBy
        createdAt
        updatedAt
      }
      articleID
      article {
        id
        code
        title
        articleType {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        articleTypeID
        number
        isActive
        mandatorCode
        createdBy
        createdAt
        updatedAt
      }
      createdBy
      validFrom
      validTill
      marketingTypeID
      marketingType {
        id
        code
        description
        marketingTypeGroup {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        marketingTypeGroupID
        isOrderConsumption
        isNGW
        isPsb
        createdBy
        createdAt
        updatedAt
      }
      reason
      approvedControllingBy
      approvedPublisherBy
      createdAt
      updatedAt
    }
  }
`;
export const listOverwriteMonthInAboNulls = /* GraphQL */ `
  query ListOverwriteMonthInAboNulls(
    $filter: ModelOverwriteMonthInAboNullFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOverwriteMonthInAboNulls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        minMax
        monthThreshold
        conditionID
        condition {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        articleID
        article {
          id
          code
          title
          articleTypeID
          number
          isActive
          mandatorCode
          createdBy
          createdAt
          updatedAt
        }
        createdBy
        validFrom
        validTill
        marketingTypeID
        marketingType {
          id
          code
          description
          marketingTypeGroupID
          isOrderConsumption
          isNGW
          isPsb
          createdBy
          createdAt
          updatedAt
        }
        reason
        approvedControllingBy
        approvedPublisherBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrderCompensation = /* GraphQL */ `
  query GetOrderCompensation($id: ID!) {
    getOrderCompensation(id: $id) {
      id
      price
      validFrom
      description
      marketingTypeID
      marketingType {
        id
        code
        description
        marketingTypeGroup {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        marketingTypeGroupID
        isOrderConsumption
        isNGW
        isPsb
        createdBy
        createdAt
        updatedAt
      }
      articleID
      article {
        id
        code
        title
        articleType {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        articleTypeID
        number
        isActive
        mandatorCode
        createdBy
        createdAt
        updatedAt
      }
      approvedConsultingBy
      approvedConsultingOn
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listOrderCompensations = /* GraphQL */ `
  query ListOrderCompensations(
    $filter: ModelOrderCompensationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderCompensations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        price
        validFrom
        description
        marketingTypeID
        marketingType {
          id
          code
          description
          marketingTypeGroupID
          isOrderConsumption
          isNGW
          isPsb
          createdBy
          createdAt
          updatedAt
        }
        articleID
        article {
          id
          code
          title
          articleTypeID
          number
          isActive
          mandatorCode
          createdBy
          createdAt
          updatedAt
        }
        approvedConsultingBy
        approvedConsultingOn
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOverwriteArticlePrice = /* GraphQL */ `
  query GetOverwriteArticlePrice($id: ID!) {
    getOverwriteArticlePrice(id: $id) {
      id
      priceThreshold
      validFrom
      validTill
      createdBy
      description
      minMax
      reason
      type
      approvedControllingBy
      articleID
      article {
        id
        code
        title
        articleType {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        articleTypeID
        number
        isActive
        mandatorCode
        createdBy
        createdAt
        updatedAt
      }
      approvedPublisherBy
      approvedDataBy
      createdAt
      updatedAt
    }
  }
`;
export const listOverwriteArticlePrices = /* GraphQL */ `
  query ListOverwriteArticlePrices(
    $filter: ModelOverwriteArticlePriceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOverwriteArticlePrices(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        priceThreshold
        validFrom
        validTill
        createdBy
        description
        minMax
        reason
        type
        approvedControllingBy
        articleID
        article {
          id
          code
          title
          articleTypeID
          number
          isActive
          mandatorCode
          createdBy
          createdAt
          updatedAt
        }
        approvedPublisherBy
        approvedDataBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMarketingType = /* GraphQL */ `
  query GetMarketingType($id: ID!) {
    getMarketingType(id: $id) {
      id
      code
      description
      marketingTypeGroup {
        id
        code
        name
        description
        marketingTypes {
          id
          code
          description
          marketingTypeGroupID
          isOrderConsumption
          isNGW
          isPsb
          createdBy
          createdAt
          updatedAt
        }
        createdBy
        createdAt
        updatedAt
      }
      marketingTypeGroupID
      isOrderConsumption
      isNGW
      isPsb
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listMarketingTypes = /* GraphQL */ `
  query ListMarketingTypes(
    $filter: ModelMarketingTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMarketingTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        description
        marketingTypeGroup {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        marketingTypeGroupID
        isOrderConsumption
        isNGW
        isPsb
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getArticle = /* GraphQL */ `
  query GetArticle($id: ID!) {
    getArticle(id: $id) {
      id
      code
      title
      articleType {
        id
        code
        name
        description
        createdBy
        createdAt
        updatedAt
      }
      articleTypeID
      number
      isActive
      mandatorCode
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listArticles = /* GraphQL */ `
  query ListArticles(
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        title
        articleType {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        articleTypeID
        number
        isActive
        mandatorCode
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPriceSegmentOverwrite = /* GraphQL */ `
  query GetPriceSegmentOverwrite($id: ID!) {
    getPriceSegmentOverwrite(id: $id) {
      id
      articleID
      article {
        id
        code
        title
        articleType {
          id
          code
          name
          description
          createdBy
          createdAt
          updatedAt
        }
        articleTypeID
        number
        isActive
        mandatorCode
        createdBy
        createdAt
        updatedAt
      }
      priceSegment
      reason
      validFrom
      validTill
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const listPriceSegmentOverwrites = /* GraphQL */ `
  query ListPriceSegmentOverwrites(
    $filter: ModelPriceSegmentOverwriteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPriceSegmentOverwrites(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        articleID
        article {
          id
          code
          title
          articleTypeID
          number
          isActive
          mandatorCode
          createdBy
          createdAt
          updatedAt
        }
        priceSegment
        reason
        validFrom
        validTill
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAffiliateHardMapping = /* GraphQL */ `
  query GetAffiliateHardMapping($id: ID!) {
    getAffiliateHardMapping(id: $id) {
      id
      affiliateSource
      affiliateTarget
      createdBy
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listAffiliateHardMappings = /* GraphQL */ `
  query ListAffiliateHardMappings(
    $filter: ModelAffiliateHardMappingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAffiliateHardMappings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        affiliateSource
        affiliateTarget
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const affiliateHardMappingByCreatedDate = /* GraphQL */ `
  query AffiliateHardMappingByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAffiliateHardMappingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    affiliateHardMappingByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        affiliateSource
        affiliateTarget
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCooperationCost = /* GraphQL */ `
  query GetCooperationCost($id: ID!) {
    getCooperationCost(id: $id) {
      id
      affiliate
      costPerLead
      totalCost
      fromDate
      untilDate
      createdBy
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listCooperationCosts = /* GraphQL */ `
  query ListCooperationCosts(
    $filter: ModelCooperationCostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCooperationCosts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        affiliate
        costPerLead
        totalCost
        fromDate
        untilDate
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const cooperationCostByCreatedDate = /* GraphQL */ `
  query CooperationCostByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCooperationCostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cooperationCostByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        affiliate
        costPerLead
        totalCost
        fromDate
        untilDate
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNetworkType = /* GraphQL */ `
  query GetNetworkType($id: ID!) {
    getNetworkType(id: $id) {
      id
      cd
      description
      createdBy
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listNetworkTypes = /* GraphQL */ `
  query ListNetworkTypes(
    $filter: ModelNetworkTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNetworkTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cd
        description
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const networkTypeByCreatedDate = /* GraphQL */ `
  query NetworkTypeByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNetworkTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    networkTypeByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cd
        description
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAffiliateType = /* GraphQL */ `
  query GetAffiliateType($id: ID!) {
    getAffiliateType(id: $id) {
      id
      cd
      description
      createdBy
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listAffiliateTypes = /* GraphQL */ `
  query ListAffiliateTypes(
    $filter: ModelAffiliateTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAffiliateTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cd
        description
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const affiliateTypeByCreatedDate = /* GraphQL */ `
  query AffiliateTypeByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAffiliateTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    affiliateTypeByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cd
        description
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAgency = /* GraphQL */ `
  query GetAgency($id: ID!) {
    getAgency(id: $id) {
      id
      cd
      name
      createdBy
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listAgencies = /* GraphQL */ `
  query ListAgencies(
    $filter: ModelAgencyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgencies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cd
        name
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const agencyByCreatedDate = /* GraphQL */ `
  query AgencyByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAgencyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    agencyByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cd
        name
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAgencyCost = /* GraphQL */ `
  query GetAgencyCost($id: ID!) {
    getAgencyCost(id: $id) {
      id
      agency {
        id
        cd
        name
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      network {
        id
        cd
        name
        channelCd
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      affiliateType {
        id
        cd
        description
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      targetGroup {
        id
        name
        subpublisher {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          subpublisherPlanningDivisionId
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        targetGroupSubpublisherId
      }
      subpublisher {
        id
        cd
        name
        planningDivision {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        subpublisherPlanningDivisionId
      }
      newsletter {
        id
        cd
        name
        targetGroup {
          id
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          targetGroupSubpublisherId
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        newsletterTargetGroupId
      }
      fromDate
      freeText
      totalCost
      createdBy
      sortKey
      createdAt
      updatedAt
      agencyCostAgencyId
      agencyCostNetworkId
      agencyCostAffiliateTypeId
      agencyCostTargetGroupId
      agencyCostSubpublisherId
      agencyCostNewsletterId
    }
  }
`;
export const listAgencyCosts = /* GraphQL */ `
  query ListAgencyCosts(
    $filter: ModelAgencyCostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgencyCosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        agency {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        network {
          id
          cd
          name
          channelCd
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        affiliateType {
          id
          cd
          description
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        targetGroup {
          id
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          targetGroupSubpublisherId
        }
        subpublisher {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          subpublisherPlanningDivisionId
        }
        newsletter {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          newsletterTargetGroupId
        }
        fromDate
        freeText
        totalCost
        createdBy
        sortKey
        createdAt
        updatedAt
        agencyCostAgencyId
        agencyCostNetworkId
        agencyCostAffiliateTypeId
        agencyCostTargetGroupId
        agencyCostSubpublisherId
        agencyCostNewsletterId
      }
      nextToken
    }
  }
`;
export const agencyCostByCreatedDate = /* GraphQL */ `
  query AgencyCostByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAgencyCostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    agencyCostByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        agency {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        network {
          id
          cd
          name
          channelCd
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        affiliateType {
          id
          cd
          description
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        targetGroup {
          id
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          targetGroupSubpublisherId
        }
        subpublisher {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          subpublisherPlanningDivisionId
        }
        newsletter {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          newsletterTargetGroupId
        }
        fromDate
        freeText
        totalCost
        createdBy
        sortKey
        createdAt
        updatedAt
        agencyCostAgencyId
        agencyCostNetworkId
        agencyCostAffiliateTypeId
        agencyCostTargetGroupId
        agencyCostSubpublisherId
        agencyCostNewsletterId
      }
      nextToken
    }
  }
`;
export const getNetwork = /* GraphQL */ `
  query GetNetwork($id: ID!) {
    getNetwork(id: $id) {
      id
      cd
      name
      channelCd
      createdBy
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listNetworks = /* GraphQL */ `
  query ListNetworks(
    $filter: ModelNetworkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNetworks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cd
        name
        channelCd
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const networkByCreatedDate = /* GraphQL */ `
  query NetworkByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNetworkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    networkByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cd
        name
        channelCd
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTargetGroup = /* GraphQL */ `
  query GetTargetGroup($id: ID!) {
    getTargetGroup(id: $id) {
      id
      name
      subpublisher {
        id
        cd
        name
        planningDivision {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        subpublisherPlanningDivisionId
      }
      createdBy
      sortKey
      createdAt
      updatedAt
      targetGroupSubpublisherId
    }
  }
`;
export const listTargetGroups = /* GraphQL */ `
  query ListTargetGroups(
    $filter: ModelTargetGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTargetGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        subpublisher {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          subpublisherPlanningDivisionId
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        targetGroupSubpublisherId
      }
      nextToken
    }
  }
`;
export const targetGroupByCreatedDate = /* GraphQL */ `
  query TargetGroupByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTargetGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    targetGroupByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        subpublisher {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          subpublisherPlanningDivisionId
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        targetGroupSubpublisherId
      }
      nextToken
    }
  }
`;
export const getNewsletter = /* GraphQL */ `
  query GetNewsletter($id: ID!) {
    getNewsletter(id: $id) {
      id
      cd
      name
      targetGroup {
        id
        name
        subpublisher {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          subpublisherPlanningDivisionId
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        targetGroupSubpublisherId
      }
      createdBy
      sortKey
      createdAt
      updatedAt
      newsletterTargetGroupId
    }
  }
`;
export const listNewsletters = /* GraphQL */ `
  query ListNewsletters(
    $filter: ModelNewsletterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNewsletters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cd
        name
        targetGroup {
          id
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          targetGroupSubpublisherId
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        newsletterTargetGroupId
      }
      nextToken
    }
  }
`;
export const newsletterByCreatedDate = /* GraphQL */ `
  query NewsletterByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsletterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsletterByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cd
        name
        targetGroup {
          id
          name
          createdBy
          sortKey
          createdAt
          updatedAt
          targetGroupSubpublisherId
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        newsletterTargetGroupId
      }
      nextToken
    }
  }
`;
export const getSubpublisher = /* GraphQL */ `
  query GetSubpublisher($id: ID!) {
    getSubpublisher(id: $id) {
      id
      cd
      name
      planningDivision {
        id
        cd
        name
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      createdBy
      sortKey
      createdAt
      updatedAt
      subpublisherPlanningDivisionId
    }
  }
`;
export const listSubpublishers = /* GraphQL */ `
  query ListSubpublishers(
    $filter: ModelSubpublisherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubpublishers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cd
        name
        planningDivision {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        subpublisherPlanningDivisionId
      }
      nextToken
    }
  }
`;
export const subpublisherByCreatedDate = /* GraphQL */ `
  query SubpublisherByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubpublisherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subpublisherByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cd
        name
        planningDivision {
          id
          cd
          name
          createdBy
          sortKey
          createdAt
          updatedAt
        }
        createdBy
        sortKey
        createdAt
        updatedAt
        subpublisherPlanningDivisionId
      }
      nextToken
    }
  }
`;
export const getPlanningDivision = /* GraphQL */ `
  query GetPlanningDivision($id: ID!) {
    getPlanningDivision(id: $id) {
      id
      cd
      name
      createdBy
      sortKey
      createdAt
      updatedAt
    }
  }
`;
export const listPlanningDivisions = /* GraphQL */ `
  query ListPlanningDivisions(
    $filter: ModelPlanningDivisionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlanningDivisions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cd
        name
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const planningDivisionByCreatedDate = /* GraphQL */ `
  query PlanningDivisionByCreatedDate(
    $sortKey: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPlanningDivisionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    planningDivisionByCreatedDate(
      sortKey: $sortKey
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cd
        name
        createdBy
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOverwriteArticle = /* GraphQL */ `
  query GetOverwriteArticle($id: ID!) {
    getOverwriteArticle(id: $id) {
      active
      article_code
      controller
      controller_confirmed
      createdBy
      manager
      manager_confirmed
      mandator_cd
      marketing_type_cd
      article_displayname
      ngw
      ngw_based_costs_percentage
      ngw_based_costs_percentage_overwritten
      ngw_cost
      ngw_cost_original
      ngw_cost_overwritten_value
      ngw_costs_overwritten
      ngw_factor_overwritten_value
      reason
      usrmail
      subpublisher_displayname
      timestamp
      valid_from
      valid_until
      delete_marked
      expired
      handled
      id
      createdAt
      updatedAt
    }
  }
`;
export const listOverwriteArticles = /* GraphQL */ `
  query ListOverwriteArticles(
    $filter: ModelOverwriteArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOverwriteArticles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        active
        article_code
        controller
        controller_confirmed
        createdBy
        manager
        manager_confirmed
        mandator_cd
        marketing_type_cd
        article_displayname
        ngw
        ngw_based_costs_percentage
        ngw_based_costs_percentage_overwritten
        ngw_cost
        ngw_cost_original
        ngw_cost_overwritten_value
        ngw_costs_overwritten
        ngw_factor_overwritten_value
        reason
        usrmail
        subpublisher_displayname
        timestamp
        valid_from
        valid_until
        delete_marked
        expired
        handled
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOverwriteWKZ = /* GraphQL */ `
  query GetOverwriteWKZ($id: ID!) {
    getOverwriteWKZ(id: $id) {
      active
      controller
      controller_confirmed
      createdBy
      delete_marked
      manager
      manager_confirmed
      mandator_cd
      marketing_cd
      ngw
      ngw_based_costs_percentage
      ngw_based_costs_percentage_overwritten
      ngw_cost
      ngw_cost_original
      ngw_cost_overwritten_value
      ngw_costs_overwritten
      ngw_factor_overwritten_value
      usrmail
      reason
      subpublisher_displayname
      timestamp
      valid_from
      valid_until
      expired
      handled
      id
      createdAt
      updatedAt
    }
  }
`;
export const listOverwriteWKZS = /* GraphQL */ `
  query ListOverwriteWKZS(
    $filter: ModelOverwriteWKZFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOverwriteWKZS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        active
        controller
        controller_confirmed
        createdBy
        delete_marked
        manager
        manager_confirmed
        mandator_cd
        marketing_cd
        ngw
        ngw_based_costs_percentage
        ngw_based_costs_percentage_overwritten
        ngw_cost
        ngw_cost_original
        ngw_cost_overwritten_value
        ngw_costs_overwritten
        ngw_factor_overwritten_value
        usrmail
        reason
        subpublisher_displayname
        timestamp
        valid_from
        valid_until
        expired
        handled
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOverwriteNGW = /* GraphQL */ `
  query GetOverwriteNGW($id: ID!) {
    getOverwriteNGW(id: $id) {
      active
      anfo_month
      article_cd
      article_code
      article_displayname
      cas_00_r03
      cas_36_r03
      condition_group
      controller
      controller_confirmed
      createdBy
      delete_marked
      expired
      handled
      mandator_cd
      manager
      manager_confirmed
      marketing_type_cd
      marketing_sub_type_cd
      ov_cp
      ov_cp_minMax
      ov_cp_contractPayedRatioThreshold
      ov_m
      ov_m_minMax
      ov_m_monthThreshold
      reason
      subpublisher_displayname
      timestamp
      usrmail
      valid_from
      valid_until
      ngwValue
      newNGW
      id
      createdAt
      updatedAt
    }
  }
`;
export const listOverwriteNGWS = /* GraphQL */ `
  query ListOverwriteNGWS(
    $filter: ModelOverwriteNGWFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOverwriteNGWS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        active
        anfo_month
        article_cd
        article_code
        article_displayname
        cas_00_r03
        cas_36_r03
        condition_group
        controller
        controller_confirmed
        createdBy
        delete_marked
        expired
        handled
        mandator_cd
        manager
        manager_confirmed
        marketing_type_cd
        marketing_sub_type_cd
        ov_cp
        ov_cp_minMax
        ov_cp_contractPayedRatioThreshold
        ov_m
        ov_m_minMax
        ov_m_monthThreshold
        reason
        subpublisher_displayname
        timestamp
        usrmail
        valid_from
        valid_until
        ngwValue
        newNGW
        id
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
